"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get WorkflowModel () {
        return WorkflowModel;
    },
    get WorkflowTemplateModel () {
        return WorkflowTemplateModel;
    },
    get WorkflowTodoModel () {
        return WorkflowTodoModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const WorkflowModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    archived: _zod.z.boolean().optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    completed: _zod.z.boolean(),
    completed_todos: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    deleted: _zod.z.boolean().optional(),
    due_date: _zod.z.date(),
    has_unassigned: _zod.z.boolean(),
    job_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    name: _zod.z.string(),
    start_date: _zod.z.date(),
    subject: _zod.z.instanceof(_bson.ObjectId),
    template: _zod.z.instanceof(_bson.ObjectId),
    todos: _zod.z.array(_zod.z.instanceof(_bson.ObjectId))
});
const WorkflowTemplateModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    action_sequence: _zod.z.array(_zod.z.object({
        action: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        actor: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        days_to_complete: _zod.z.union([
            _zod.z.number(),
            _zod.z.null()
        ]),
        signature_request_template_id: _zod.z.union([
            _zod.z.instanceof(_bson.ObjectId),
            _zod.z.null()
        ]),
        signers: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional()
    })).optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean().optional(),
    last_update: _zod.z.date().optional(),
    name: _zod.z.string(),
    sequences: _zod.z.array(_zod.z.string()).optional()
});
const WorkflowTodoModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    action: _zod.z.string(),
    actor: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]),
    company: _zod.z.instanceof(_bson.ObjectId),
    date_done: _zod.z.date().optional(),
    doer: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]).optional(),
    done: _zod.z.boolean(),
    due_date: _zod.z.date(),
    signature_request: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]).optional(),
    start_date: _zod.z.date(),
    subject: _zod.z.instanceof(_bson.ObjectId),
    waiting: _zod.z.boolean(),
    workflow: _zod.z.instanceof(_bson.ObjectId)
});
